import * as React from 'react';

import * as styles from './styles.css';

interface ILandingBlockProps {
  children: React.ReactNode;
}

export function LandingBlock({ children }: ILandingBlockProps) {
  return <div className={styles['block']}>{children}</div>;
}
